<template>
    <p class="mt-2 text-xs italic text-red-500">
        {{ errors[0] }}
    </p>
</template>
<script>
export default {
    props: {
        errors: {
            type: Array,
            required: true,
        },
    },
};
</script>